import "./index.scss";
import unsubscribeImg from "../../assets/img/unsubscribe-image.gif";
import edward from "../../assets/img/edward.png";
export default function Unsubscribe(props) {
  return (
    <section className="page-section  ">
      <div className="container p-3" style={{ minHeight: "calc(100vh)" }}>
        <div className="d-flex justify-content-center unsubscribe-animation">
          <img  alt=""   src={unsubscribeImg} />
        </div>

        <div className="message-body text-dark">
          <h4>
            <b className="mb-2">سپاس از شما و بدرود.</b>
          </h4>
          <p className="text-body">
            شما با موفقیت از لیست ارسال پیام‌های زبانشناس حذف شدید و دیگر پیامک
            و ایمیلی از ما دریافت نخواهید کرد. اگر به اشتباه دستتون روی این
            گزینه خورده، میتونید از{" "}
            <button
              onClick={props.showResubscribePage}
              type="button"
              className="btn btn-link pt-0 pb-0 ps-1 pe-1"
            >
              اینجا
            </button>{" "}
            مجددا برگردید.
          </p>
          <div className="text-muted mt-5">
            <p>
              "اما سرنوشت حکم می کند که عزیزترین دوستان نیز باید از هم جدا
              شوند."
            </p>
          </div>
          <div className="d-flex align-items-center">
            <div>
              <img width="70" src={edward} alt="" />
            </div>
            <div className="me-3 text-black-50">
              {" "}
              <div>Edward Young</div> <div> شاعر بریتانیایی </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
